import { createFileRoute } from "@tanstack/react-router";
import { FleetAlertsPage } from "../../../components/fleet/FleetAlertsPage";
import { requireModuleAccess, MODULE_FLEET_MANAGEMENT } from "../../../lib/auth/route-protection";

export const Route = createFileRoute("/fleet/alerts/")({
  beforeLoad: requireModuleAccess(MODULE_FLEET_MANAGEMENT),
  component: FleetAlertsPage,
});
